import { clusters } from '../data/clusters.const'

export default class {
    static getIndexByNumber(cluster, type, number) {
        return clusters[cluster][type].findIndex(lesson => lesson.nummer == number);
    }

    static getLesson(cluster, type, index) {
        if(!clusters[cluster] || !clusters[cluster][type]) return;

        return clusters[cluster][type][index];
    }

    static getLessonByNumber(cluster, type, number) {
        if (!clusters[cluster] || !clusters[cluster][type]) return {};

        return clusters[cluster][type].find((lesson) => {
            return lesson.nummer == number;
        }) || {};
    }
}